import { APIService } from "../../../../../../network/api/APIService";

export const AdminAffiliateDashboardData = (query = {}) => {
    return APIService({
        endpoint: "/affiliate/admin/dashboard/",
        method: "GET",
        query,
    });
};
